module.exports = __webpack_public_path__ + "static/media/Krowd_logo.2cc01c22.jpg";